import { initializeIcons, registerIcons } from '@fluentui/react';
import StampIcon from 'assets/svgs/ApproveStatusIcons/Stamp.svg?react';
import FullView from 'assets/svgs/FullView.svg?react';
import ChatHelp from 'assets/svgs/chat_help.svg?react';
import IncognitoIcon from 'assets/svgs/incognito_filled.svg?react';

export const setupIcons = () => {
  initializeIcons();
  registerIcons({
    icons: {
      Stamp: <StampIcon style={{ width: 25, height: 30 }} />,
      StampSmall: <StampIcon style={{ width: 20, height: 18 }} />,
      FullView: <FullView style={{ width: 15, height: 15 }} />,
      ChatHelp: <ChatHelp style={{ width: 24, height: 24 }} />,
    },
  });
  registerIcons({
    icons: {
      Incognito: <IncognitoIcon style={{ width: 25, height: 30 }} />,
      IncognitoSmall: <IncognitoIcon style={{ width: 20, height: 18 }} />,
    },
  });
};
